import {DomainEvent} from './DomainEvent';
import {Gallery} from '../resources/Gallery';

export class GalleryUpdated extends DomainEvent<Gallery> {}
